import {request} from "@/utils/request";
//获取学期
export function teachingSemesterList(query) {
  return request({
    url: '/teachingCenter/teachingSemester/list',
    method: 'get',
    params: query
  })
}
//获取专业
export function teachingMajorList(query) {
  return request({
    url: '/teachingCenter/teachingMajor/list',
    method: 'get',
    params: query
  })
}
// 年级维护-查询
export function teachingGradeList(query) {
  return request({
    url: '/system/classes/list',
    method: 'get',
    params: query
  })
}
// 查询课程表
export function listTimetable(params){
  return request({
    url:"/teachingCenter/teachingSemester/getSchoolTimetable",
    method:"get",
    params:params
  })
}
export function getH5SchoolTimetable(params){
  return request({
    url:"/teachingCenter/teachingSemester/getH5SchoolTimetable",
    method:"get",
    params:params
  })
}
//教学计划-详情
export function teachingPlanDetail(id) {
  return request({
    url: '/teachingCenter/teachingPlan/detail/'+id,
    method: 'get',
  })
}
//教学计划-详情
export function teachingPlanDetailProcess(id,data) {
  return request({
    url: '/teachingCenter/teachingPlanDetail/detail/'+id,
    method: 'get',
    params: data
  })
}
//打卡
export function teachingPlanClock(data) {
  return request({
    url: '/teachingCenter/teachingPlanClock/save',
    method: 'post',
    data: data
  })
}
//查询打卡信息
export function userClockInfo(data) {
  return request({
    url: '/teachingCenter/teachingPlanClock/userClockInfo',
    method: 'get',
    params: data
  })
}
//查询学员
export function listPaperStudent(data) {
  return request({
    url: '/teachingCenter/teachingPlanStudent/listPaperStudent',
    method: 'get',
    params: data
  })
}
//查看学员作业
export function listHomeworkStudent(query) {
  return request({
    url: '/teachingCenter/teachingPlanStudent/listHomeworkStudent',
    method: 'get',
    params: query
  })
}
//作业评分
export function updateScoreBatch(data) {
  return request({
    url: '/teachingCenter/teachingPlanHomework/updateScoreBatch',
    method: 'post',
    data: data
  })
}
export function updateScoreCriteriaBatch(data) {
  return request({
    url: '/teachingCenter/teachingPlanCriteria/updateScoreBatch',
    method: 'post',
    data: data
  })
}
export function teachingPlanStudent(data) {
  return request({
    url: '/teachingCenter/teachingPlanStudent/listCriteriaStudent',
    method: 'get',
    params: data
  })
}
export function teachingStudent(data) {
  return request({
    url: '/teachingCenter/teachingPlanStudent/listStudent',
    method: 'get',
    params: data
  })
}
//根据类型查询不同的评分表模板
export function teachingPlanRatingCriteria(id) {
  return request({
    url: '/teachingCenter/teachingPlanRatingCriteria/getByRatingId/'+id,
    method: 'get',
  })
}
export function teachingPlandetailById(data) {
  return request({
    url: '/teachingCenter/teachingPlanRatingCriteria/detailById/'+data.planDetailId+'/'+data.ratingCriteriaId+'/'+data.userId,
    method: 'get',
  })
}
//保存评分表
export function saveCriteria(data) {
  return request({
    url: '/teachingCenter/teachingPlanRatingCriteria/saveCriteria',
    method: 'post',
    data:data
  })
}
//开始答题
export function studentSaveCriteria(data) {
  return request({
    url: '/teachingCenter/teachingPlanStudent/saveCriteria',
    method: 'post',
    data:data
  })
}
// 课程评价建议-新增
export function teachingPlanDetailSuggestSave(data){
  return request({
    url: '/teachingCenter/teachingPlanDetailSuggest/save',
    method:"post",
    data
  })
}
//课程评价建议-查询
export function teachingPlanDetailSuggestList(params) {
  return request({
    url: `/teachingCenter/teachingPlanDetailSuggest/list`,
    method: 'get',
    params
  })
}
